(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pl-quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pl-quick-add')) {
    let active = null;

    customElements.define(
      'pl-quick-add',
      class extends HTMLElement {
        connectedCallback() {
          if (active && active.isConnected) return;
          active = this;
          this.dialog = this.querySelector('dialog');
          this.grid = this.querySelector('.pl-qa__grid');
          this.addButton = this.querySelector('.pl-qa__add');
          this.error = this.querySelector('.pl-qa__error');
          this.legendDefault = this.querySelector('.pl-qa__legend').textContent;
          this.abort = new AbortController();
          document.addEventListener('click', this.onDocumentClick, { signal: this.abort.signal });
          this.addButton.addEventListener('click', this.onAdd, { signal: this.abort.signal });
          this.dialog.addEventListener('click', this.onBackdropClick, { signal: this.abort.signal });
        }

        disconnectedCallback() {
          this.abort?.abort();
          if (active === this) active = null;
        }

        onDocumentClick = (event) => {
          const trigger = event.target instanceof Element ? event.target.closest('[data-pl-qa-open]') : null;
          if (!trigger) return;
          const source = trigger.parentElement?.querySelector('[data-pl-qa-data]');
          if (!source) return;
          event.preventDefault();
          try {
            this.open(JSON.parse(source.textContent));
          } catch (error) {
            console.warn('[pl-quick-add] Invalid product data', error);
          }
        };

        onBackdropClick = (event) => {
          if (event.target === this.dialog) this.dialog.close();
        };

        open(data) {
          this.data = data;
          this.selected = data.variants.find((variant) => variant.available) || data.variants[0];
          this.querySelector('.pl-qa__label').textContent = data.label || '';
          const name = this.querySelector('.pl-qa__name');
          name.textContent = data.name;
          name.href = data.url;
          const img = this.querySelector('.pl-qa__img');
          img.hidden = !data.image;
          if (data.image) img.src = data.image;
          this.error.hidden = true;
          this.querySelector('.pl-qa__legend').textContent = data.option || this.legendDefault;
          this.renderOptions();
          this.dialog.showModal();
        }

        renderOptions() {
          this.grid.replaceChildren();
          for (const variant of this.data.variants) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'pl-qa__option';
            button.disabled = !variant.available;
            button.setAttribute('aria-pressed', String(variant === this.selected));
            const title = document.createElement('span');
            title.className = 'pl-qa__option-title';
            title.textContent = variant.title;
            const price = document.createElement('span');
            price.className = 'pl-qa__option-price';
            price.textContent = variant.available ? variant.price : this.dataset.soldOut;
            button.append(title, price);
            if (variant.gross && variant.available) {
              const gross = document.createElement('span');
              gross.className = 'pl-qa__option-vat';
              gross.textContent = variant.gross;
              button.append(gross);
            }
            if (variant.unit) {
              const unit = document.createElement('span');
              unit.className = 'pl-qa__option-unit';
              unit.textContent = `${variant.unit} / 100 g`;
              button.append(unit);
            }
            if (variant.save > 0) {
              const save = document.createElement('span');
              save.className = 'pl-qa__option-save';
              save.textContent = `−${variant.save} %`;
              button.append(save);
            }
            button.addEventListener('click', () => {
              this.selected = variant;
              this.renderOptions();
            });
            this.grid.append(button);
          }
          this.querySelector('.pl-qa__price').textContent = this.selected?.price ? `${this.selected.price} ${this.dataset.noVat}` : '';
          this.querySelector('.pl-qa__vat').textContent = this.selected?.gross || '';
          this.addButton.disabled = !this.selected?.available;
        }

        onAdd = async () => {
          if (!this.selected?.available) return;
          const id = this.selected.id;
          this.addButton.disabled = true;
          this.addButton.textContent = this.dataset.adding;
          this.error.hidden = true;
          try {
            if (window.Shopify?.actions?.updateCart) {
              const result = await window.Shopify.actions.updateCart(
                { lines: [{ merchandiseId: `gid://shopify/ProductVariant/${id}`, quantity: 1 }] },
                { context: 'dialog' }
              );
              if (result?.userErrors?.length) throw new Error(result.userErrors[0].message);
              this.dialog.close();
            } else {
              const root = window.Shopify?.routes?.root || '/';
              const response = await fetch(`${root}cart/add.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
              });
              if (!response.ok) throw new Error((await response.json())?.description);
              window.location.href = `${root}cart`;
            }
          } catch (error) {
            this.error.textContent = error?.message || this.dataset.error;
            this.error.hidden = false;
          } finally {
            this.addButton.disabled = false;
            this.addButton.textContent = this.dataset.add;
          }
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
